import { axiosInstanceWebsite } from "../instance";

export const getUserSettings = async () => {
    const response = await axiosInstanceWebsite.get(`/user/settings`);
    return response.data;
};

export interface UserSettingsPayloadInterface {
    country: string,
    currency: string,
    language: string,
    time_zone?: string,
};

export const upsertUserSettings = async (data: UserSettingsPayloadInterface) => {
    const response = await axiosInstanceWebsite.put(`/user/settings`, data);
    return response.data;
};